












































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { RelatorioServicosSaudeModel } from "@/models/administracao/servicos-saude/RelatorioServicosSaudeModel";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import { tipoServicoSaudeList } from "@/models/commons/TipoServicoModel";
import { statusServicos } from "@/models/commons/StatusServicosModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GerencialServicosSaudeService from "@/service/relatorio/gerencial/GerencialServicosSaudeService";
import axios, { AxiosResponse } from "axios";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioServicosSaude extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsibleOpened = false;

  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  tipoServicos = tipoServicoSaudeList;
  perfis = [
    { name: 'PF', descricao: 'Pessoa Física' },
    { name: 'PJ', descricao: 'Pessoa Jurídica'}
  ];
  tipoAtendimentos = [
    { name: "AGENDAMENTO", descricao: "Agendamento" },
    { name: "VOUCHER", descricao: "Voucher" },
  ];
  status = [{ name: "REMARCACAO", descricao: "Remarcação" }, ...statusServicos];
  categorias = [
    { valor: "ASSISTENCIA_24H", descricao: "Assistência 24h" },
    { valor: "ORCAMENTO_AUTOMOTIVO", descricao: "Orçamento Automotivo Online" },
  ];
  relatorio: RelatorioServicosSaudeModel = {
    inicio: undefined,
    fim: undefined,
  };

  mounted() {
    axios
      .get<EstadosCidadesResponse>("/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));
  }

  @Watch("relatorio.estado")
  private selectCities(): void {
    if (this.relatorio.estado) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.relatorio.estado?.sigla
      )[0].cidades;
    }
  }

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialServicosSaudeService.gerarRelatorio(tipo, this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              `relatorio_servicos_saude.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  public toggleCollapsible(): void {
    this.collapsibleOpened = !this.collapsibleOpened;
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
